import { IconButton, InputAdornment, TextField } from "@mui/material";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { BsCart4 } from "react-icons/bs";
import { FaSearch } from "react-icons/fa";
import { useEventSession } from "../../providers/eventSessions";
import { IEventSession } from "../../providers/eventSessions/eventsSessions.interface";
import { IEvent } from "../../providers/events/events.interface";
import { useUser } from "../../providers/users";
import EventSessionsList from "../EventSessionList";
import PaginatedItems from "../Paginate";
import PageHeader from "../pageHeader";
import { Container } from "./styles";
interface IProps {
  event: IEvent;
}

const EventeSessionContainer = ({ event }: IProps) => {
  const { roleAdmin } = useUser();
  const { allEventSessions } = useEventSession();
  const { t } = useTranslation();
  const [eventName, setEventName] = useState("");
  // Adicionar estado para controlar a página atual
  const [page, setPage] = useState(0);

  const eventEventSessions = allEventSessions
    ? allEventSessions.filter((e: IEventSession) => e.eventId === event.id)
    : [];
  const filteredEventSessions: IEventSession[] = eventEventSessions
    ? eventEventSessions.filter((e: IEventSession) =>
        e.name.toLowerCase().includes(eventName.toLowerCase())
      )
    : [];

  // Resetar a página para 0 quando o eventName mudar
  useEffect(() => {
    setPage(0);
  }, [eventName]);

  // Função para lidar com a mudança de texto
  const handleTextChange = (e) => {
    setEventName(e.target.value);
    // O reset da página acontecerá pelo useEffect acima
  };

  useEffect(() => {}, [allEventSessions]);

  return (
    <Container>
      <PageHeader
        title={t("event_sessions")}
        description={event.description}
        buttonContent={t("create")}
        buttonPath={`events/${event.id}/eventsessions/create`}
        verifyRole={true}
        roleToVerify={roleAdmin}
        icon={<BsCart4 />}
      />
      <section className="filterSection">
        <TextField
          InputProps={{
            disableUnderline: true,
            endAdornment: (
              <InputAdornment position="end">
                <IconButton aria-label="search event">
                  {<FaSearch />}
                </IconButton>
              </InputAdornment>
            ),
          }}
          id="standard-search"
          label={t("search_event_session")}
          type={"text"}
          value={eventName}
          onChange={handleTextChange}
          variant="filled"
          sx={{
            boxShadow: "rgba(3,3,3,0.1) 2px 2px 4px ",
            textAlign: "center",
            backgroundColor: "#FFF",
            "& fieldset": { border: "none" },
          }}
        />
      </section>
      {allEventSessions && (
        <PaginatedItems
          items={filteredEventSessions.sort(
            (a, b) => a.sessionNumber - b.sessionNumber
          )}
          itemsPerPage={3}
          Items={EventSessionsList}
          forcePage={page}
          onPageChange={setPage}
        />
      )}
    </Container>
  );
};

export default EventeSessionContainer;
